import * as React from 'react';
import Flex from 'ui/Flex/Flex';
import { Skeleton } from '@mui/material';

const BlogArticleCardLoading = (): JSX.Element => (
    <Flex direction="column" align="start" sx={{ width: '100%' }}>
        <Skeleton
            variant="rectangular"
            sx={{
                height: '232px',
                width: '100%',
                borderRadius: '12px',
                backgroundColor: 'white',
            }}
        />
        <Skeleton
            variant="text"
            sx={{ fontSize: '1rem', mt: '2rem', backgroundColor: 'white' }}
            width={80}
        />
    </Flex>
);

export default BlogArticleCardLoading;
